module.exports = __webpack_public_path__ + "static/media/zola-registry-logo-black.882b287c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/zola-registry-logo-black.svg
// module id = 2267
// module chunks = 53